import { useEffect, useState, useContext } from "react";
import SubscriptionHistory from "../../components/Subscription/History";
import CurrentSub from "../../components/Subscription/CurrentSub";
import Spinner from "../../components/UI/Spinner";
import ErrorModal from "../../components/UI/Error";
import { transactionService } from "../../services";

const TransactionHistory = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPlan, setCurrentPlan] = useState(null);
  const [error, setError] = useState(false);

  const endDateGetter = (dateStr) => {
    const date = new Date(dateStr);
    const expireDate = date.setFullYear(date.getFullYear() + 1);
    const nextYear = new Date(expireDate).toISOString();
    return nextYear.split("T")[0];
  };
  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        setError(false);
        const [myTransactions, { status }] = await Promise.all([
          transactionService.myTransaction(),
          transactionService.mySubStatus("id"),
        ]);
        const currentPlan = {
          ...myTransactions[0],
          status: status ? "Active" : "Inactive",
          endDate:
            myTransactions[0].name === "Label"
              ? endDateGetter(myTransactions[0].createdAt)
              : null,
        };
        setCurrentPlan(currentPlan);
        setTransactions(myTransactions);
      } catch (error) {
        console.log(error);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchTransactions();
  }, []);

  if (loading)
    return (
      <div className="grid place-content-center h-[60vh]">
        <Spinner />
      </div>
    );
  if (error)
    return (
      <ErrorModal
        isOpen={error}
        onClose={() => setError(false)}
        title={"Error Fetching Transactions"}
        message={
          "There is error while trying to fetch the transactions. Please check your internet contivities and refresh this page to try again"
        }
      />
    );
  return (
    <div className="bg-white rounded-2xl p-6 shadow-md text-gray-900 space-y-6">
      {/* Subscription Status Card */}
      <CurrentSub currentPlan={currentPlan} />
      {/* Transaction History */}
      <SubscriptionHistory transactions={transactions} />
    </div>
  );
};

export default TransactionHistory;
